/* eslint-disable no-unused-vars */
import { SUBDOMAIN_CHECK } from "../helpers/logicHelper"; // checks the subdomian, takes in url params
import { subDomainMapper } from "../helpers/mappers";

export const DEFAULT_BASEURL = "stag";
export const DIGITAL_BANKING_BASE_URL = "digitalbanking";
export const PAYOUT_BASE_URL = "payout";
export const REMITTANCE_BASE_URL = "remittance";
export const WALLET_BASE_URL = "wallet";
export const EMI_BASE_URL = "emi";
export const LOAN_BASE_URL = "loan";
export const LOCALHOST_BASEURL = "localhost";
export const DEV_BRANCH_BASEURL = "multiview-admin";
export const DIGITAL_BANKING_BRANCH_BASEURL = "multiview-digital-banking";
export const PAYOUT_BRANCH_BASEURL = "multiview-payout";
export const REMITTANCE_BRANCH_BASEURL = "multiview-remittance";
export const WALLET_BRANCH_BASEURL = "multiview-wallet";
export const LOAN_BRANCH_BASEURL = "multiview-loan";
export const EMI_BRANCH_BASEURL = "multiview-emi";
export const LIVE_BRANCH_BASEURL = "mta-live";

export const getSubDomain = () => {
  const subDomainBaseURL = window.location.hostname.split(".")[0];
  if (
    subDomainBaseURL === DEV_BRANCH_BASEURL ||
    subDomainBaseURL === LIVE_BRANCH_BASEURL ||
    subDomainBaseURL === LOCALHOST_BASEURL
  ) {
    return DEFAULT_BASEURL;
  } else if (subDomainBaseURL === DIGITAL_BANKING_BRANCH_BASEURL) {
    return DIGITAL_BANKING_BASE_URL;
  } else if (subDomainBaseURL === PAYOUT_BRANCH_BASEURL) {
    return PAYOUT_BASE_URL;
  } else if (subDomainBaseURL === REMITTANCE_BRANCH_BASEURL) {
    return REMITTANCE_BASE_URL;
  } else if (subDomainBaseURL === EMI_BRANCH_BASEURL) {
    return EMI_BASE_URL;
  } else if (subDomainBaseURL === WALLET_BRANCH_BASEURL) {
    return WALLET_BASE_URL;
  } else if (subDomainBaseURL === LOAN_BRANCH_BASEURL) {
    return LOAN_BASE_URL;
  } else {
    return subDomainBaseURL;
  }
  // return subDomainBaseURL === DEV_BRANCH_BASEURL ||
  //   subDomainBaseURL === LIVE_BRANCH_BASEURL ||
  //   subDomainBaseURL === LOCALHOST_BASEURL
  //   ? DEFAULT_BASEURL
  //   : subDomainBaseURL;
};

export const fetchSubDomain = () => {
  const domainURL = getSubDomain();
  const subdomainChecker = SUBDOMAIN_CHECK(window.location.hostname);
  if (domainURL === DEFAULT_BASEURL) {
    return subDomainMapper["STAG"];
  } else if (domainURL === PAYOUT_BASE_URL) {
    return subDomainMapper["MULTIVIEW-PAYOUT"];
  } else if (domainURL === REMITTANCE_BASE_URL) {
    return subDomainMapper["MULTIVIEW-REMITTANCE"];
  } else if (domainURL === DIGITAL_BANKING_BASE_URL) {
    return subDomainMapper["MULTIVIEW-DIGITAL-BANKING"];
  } else if (domainURL === EMI_BASE_URL) {
    return subDomainMapper["MULTIVIEW-EMI"];
  } else if (domainURL === WALLET_BASE_URL) {
    return subDomainMapper["MULTIVIEW-WALLET"];
  } else if (domainURL === LOAN_BASE_URL) {
    return subDomainMapper["MULTIVIEW-LOAN"];
  } else if (subdomainChecker) {
    return subDomainMapper[domainURL.toUpperCase()];
  } else {
    return (window.location.href = "https://moneytransferapplication.com/");
  }
  // return domainURL === DEFAULT_BASEURL
  //   ? subDomainMapper["STAG"]
  //   : subdomainChecker
  //   ? subDomainMapper[domainURL.toUpperCase()]
  //   : (window.location.href = "https://moneytransferapplication.com/");
};

export const getBaseUrl = () => {
  const subdomainObject = fetchSubDomain();
  return `https://${subdomainObject?.API_SUBDOMAIN}.${subdomainObject?.API_ENV?.env}`;
  // return "https://digitalbanking.moneytransferapplication.uk";
  // return "https://remittance.moneytransferapplication.uk";
  // return "https://payout.moneytransferapplication.uk";
  // return "https://emi.moneytransferapplication.uk";
  // return "https://fipay.moneytransferapplication.uk";
  // UN-COMMENT ANY OF THE ABOVE BASE-URLS TO POINT TO ITS RESPECTIVE MODULE
};
